import { render, staticRenderFns } from "./headbar.vue?vue&type=template&id=8917da6c&scoped=true"
import script from "./headbar.vue?vue&type=script&lang=js"
export * from "./headbar.vue?vue&type=script&lang=js"
import style0 from "./headbar.vue?vue&type=style&index=0&id=8917da6c&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8917da6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/centurygame/web-vip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8917da6c')) {
      api.createRecord('8917da6c', component.options)
    } else {
      api.reload('8917da6c', component.options)
    }
    module.hot.accept("./headbar.vue?vue&type=template&id=8917da6c&scoped=true", function () {
      api.rerender('8917da6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/components/src/components/headbar.vue"
export default component.exports